import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";

const initialState: any = {
  pendingApprovals: [],
  pendingApprovalDetails: {},
  isLoading: false,
  isPendingApprovalLoading: false,
  error: null,
};

export const getPendingApprovals: any = createAsyncThunk(
  "content/getPendingApprovals",
  async ({ PageNumber, pageSize, SortBy, SortDirection }: any) => {
    const res = await axios.get(`/slpapp/User/unapprovedUsers`, {
      params: { PageNumber, pageSize, SortBy, SortDirection },
    });
    const data = await res.data;

    return data;
  }
);

export const getPendingApprovalById: any = createAsyncThunk(
  "content/getPendingApprovalDetails",
  async ({ id }: any) => {
    const res = await axios.get(`/slpapp/User/UserbyId`, {
      params: { userId: id },
    });
    const data = await res.data?.data;
    // debugger;

    return data;
  }
);

export const approveUser: any = createAsyncThunk(
  "content/approveUser",
  async ({ userId }: any) => {
    const res = await axios.put(
      `/slpapp/User/approveUser`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
        params: { userId },
      }
    );
    const data = await res.data;

    return data;
  }
);

export const rejectUser: any = createAsyncThunk(
  "content/rejectUser",
  async ({ userId }: any) => {
    const res = await axios.put(
      `/slpapp/User/rejectUser`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
        params: { userId },
      }
    );
    const data = await res.data;

    return data;
  }
);

export const pendingApprovalSlice = createSlice({
  name: "pendingApproval",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPendingApprovals.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getPendingApprovals.fulfilled, (state, action) => {
      state.isLoading = false;
      state.pendingApprovals = action.payload;
    });
    builder.addCase(getPendingApprovals.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(getPendingApprovalById.pending, (state) => {
      state.isPendingApprovalLoading = true;
    });
    builder.addCase(getPendingApprovalById.fulfilled, (state, action) => {
      state.isPendingApprovalLoading = false;
      state.pendingApprovalDetails = action.payload;
    });
    builder.addCase(getPendingApprovalById.rejected, (state, action) => {
      state.isPendingApprovalLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(approveUser.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(approveUser.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(approveUser.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
  },
});

export default pendingApprovalSlice.reducer;
